import React from 'react'

import DevToolsContextProvider from './contexts/dev-tools-context.js'
//import { GraphqlViewerBtn, GraphqlViewerModal } from './tools/graphql'
//import { LoggerBtn, LoggerModal } from './tools/logger'
import { LocalizationBtn } from './tools/localization'
//import { CookiesBtn } from './tools/cookies/index.js'
import { TimeBtn } from './tools/time/index.js'
import DevToolsDrawer from './bar/drawer.js'
import DevToolsButton from './bar/button.js'

const FrameworkDevTools = () => {
  if (process.env.GATSBY_ENV === 'prod' || !process.env.GATSBY_ENV || process.env.GATSBY_DISABLE_DEVTOOLS) {
    return ''
  }

  return (
    <DevToolsContextProvider>
      <DevToolsDrawer>
        <div className="absolute left-0 h-full flex items-center">
          Current Env: <span className="bg-slate-700 flex py-2 px-4 ml-4 rounded-sm">{process.env.GATSBY_ENV}</span>
        </div>
        {process.env.GATSBY_ENV === 'dev' && (
          <>
            {/* 
            <LoggerBtn />
            <GraphqlViewerBtn /> 
            */}
          </>
        )}

        <TimeBtn />
        <LocalizationBtn />
        <DevToolsButton />
        {process.env.GATSBY_ENV === 'dev' && (
          <>
            {/* 
            <LoggerModal />
            <GraphqlViewerModal /> 
            */}
          </>
        )}
      </DevToolsDrawer>
    </DevToolsContextProvider>
  )
}

export default FrameworkDevTools
